/*
 * Module for the Benefit Recalculation History screen
*/

rs.module("framework/benefitsummary/recalculationhistory",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors) {

            // on recalc date change, post the form to reload the page
            $.js(jsSelectors.recalcDateSelect).change(function () {

                $.js(jsSelectors.loadingSpinner).show();
                this.form.submit();

            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);